import React, { useEffect, useState } from "react";
import pageLoaderImg from "../lease_management/assets/img/page-loader.gif";
import { Box } from "@mui/material";
import { isOnline, onNetworkFailure } from "../utils/networkStatus";
const PageLoader = () => {
  // hide on network failure, otherwise screens that never reset their loader stay blocked
  const [dismissed, setDismissed] = useState(() => !isOnline());
  useEffect(() => onNetworkFailure(() => setDismissed(true)), []);
  if (dismissed) return null;
  return (
    <Box sx={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0, 0, 0, 0.1)', display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, cursor: "wait", pointerEvents: "all", }} >
      <Box sx={{ position: "relative", display: "flex", flexDirection: "column", alignItems: "center", gap: 2, }} >
        <Box className="page-loader">
          <span> <img src={pageLoaderImg} alt="" style={{ width: "100px", height: "auto" }} /> </span>
        </Box>
      </Box>
    </Box>
  );
};
export default PageLoader;
